import * as React from 'react';
import {
  TextField,
  Show,
  SimpleShowLayout,
  RichTextField,
  DateField,
} from 'react-admin';

export const CouponShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="productId" label="Product ID" />
      <TextField source="code" />
      <TextField source="maxTimes" />
      <TextField source="usedTimes" />
      <RichTextField source="name" />
      <DateField source="startAt" />
      <DateField source="expiredAt" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
